import React, { Component } from 'react';
import 'primereact/resources/themes/nova-light/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import UserService from '../../services/UserService';
import CartonMasterService from '../../services/CartonMasterService';
import SecondaryPackingService from '../../services/SecondaryPackingService';
import PrintSecondaryPackagingService from '../../services/PrintSecondaryPackagingService';
import MappingService from '../../services/MappingService';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import tableRequest from '../../models/tableRequest.js';
import { confirmAlert } from 'react-confirm-alert'; // Import
import { ConfirmationModal } from '../../template/ConfirmationModal';
import MessageComponent from '../../template/Message';
import $ from 'jquery';
import Loaders from '../../template/Loaders';

export default class SecondaryPacking extends Component {
    constructor(props) {
        super(props);
        // this.UserService = new UserService();
        this.CartonMasterService = new CartonMasterService();
        this.MappingService = new MappingService();
        this.SecondaryPackingService = new SecondaryPackingService();
        this.PrintSecondaryPackagingService = new PrintSecondaryPackagingService();
        this.tblResponse = new tableRequest();
        this.state = {
            globalFilter: null,
            visible: false,
            sortIcon: false,
            productLoading: true,
            cartoonLoading: false,
            sortOrder: '1',
            formError: {

            },
            CartonDDL: [],
            // CartonId: [],
            buttonLabel: 'Submit',
            sales: [],
            scanItems: [],
            loading: true,
            first: 0,
            rows: 5,
            totalRecords: 0,
            globalFilter: null,
            emptyMessage: 'No Data found',
            //  IsDisabledCartonDDL: false,
            scanTxt: ''
        }

        this.actionTemplate = this.actionTemplate.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.submitForm = this.submitForm.bind(this);
        this.onPage = this.onPage.bind(this);
        this.searchFilter = this.searchFilter.bind(this);
        this.onSort = this.onSort.bind(this);
        this.ScanItem = this.ScanItem.bind(this);
    }
    //trigger api function on page call
    componentDidMount() {
        setTimeout(() => {
            this.GetSecondaryPacking();
        }, 1000);

        $('.p-column-title').on('click', function () {
            $(this).next().removeClass('pi-sort').toggleClass('pi-sort-up').addClass('pi-sort-down');
        });

        this.GetActiveCartonDDL();

    }
    // PAGE EVENT CALL
    onPage(event) {
        this.setState({
            loading: true
        });

        //imitate delay of a backend call
        setTimeout(() => {
            debugger

            this.getLazyLoadingValues(event);
            this.GetSecondaryPacking();
            debugger

        }, 250);
    }
    // set lazy loading values
    getLazyLoadingValues(event) {
        this.setState({ rows: event.rows });
        this.tblResponse.PageSize = event.rows;
        this.tblResponse.First = event.first + 1;
        this.tblResponse.IsActive = true;
        this.tblResponse.SearchValue = event.globalFilter ? event.globalFilter : "";
        //this.tblResponse.SortColumn = event.sortField;
        this.tblResponse.SortOrder = event.sortOrder === 1 ? 'ASC' : 'DESC';
    }

    // get users data list from api
    GetSecondaryPacking() {
        this.tblResponse.SortColumn = '';
        debugger
        this.SecondaryPackingService.GetSecondaryPacking(this.tblResponse).then(data => {

            //if ResponseData is not null
            const resdata = data.data;
            this.setState({ cartoonLoading: true });
            if (resdata !== null && resdata.ResponseData !== null && resdata.ResponseData.length > 0) {
                this.datasource = resdata.ResponseData;
                this.setState({
                    totalRecords: resdata.ResponseData[0].TotalRows,
                    first: (this.tblResponse.First - 1),
                    sales: this.datasource.slice(0, ((this.tblResponse.First - 1) + this.tblResponse.PageSize)),
                    loading: false,

                });
            }
            //if ResponseData is null
            else {
                this.datasource = null;
                this.setState({
                    totalRecords: 0,
                    first: 1,
                    sales: null,
                    loading: false
                });
            }
        });
    }
    // call every change of form and validation part also
    handleChange(event) {

        const { name, value } = event.target;
        let errors = this.state.formError;

        const isValid = this.validateForm(value, name);
        this.setState({ errors, [name]: value });
    }
    // validate form
    validateForm(value, name) {
        let errors = this.state.formError;
        let IsValid = true;
        //to validate each form field with required conditions
        switch (name) {
            case 'UserName':
                if (value.length < 1) {
                    IsValid = false;
                    errors.UserName = "Please enter your username.";
                } else errors.UserName = ''
                break;

            default:
                break;
        }
        return IsValid;
    }

    // reset form text value
    formReset() {
        this.setState({
            ReferenceID: '',
            UserName: '',
            FirstName: '',
            LastName: '',
            Email: '',
            MobileNo: '',
            Password: '',
            ConfirmPassword: '',
            IsActive: true
        });
        let errors = this.state.formError;
        Object.entries(errors).map(([key, value]) => {
            errors[key] = '';
        });
    }
    // open Dialog
    openDialog() {
        this.setState({ visible: true });
        this.formReset();
    }
    // submit packing
    submitForm(event) {
        // event.preventDefault();
        if (this.state.PackOF == 0) {
            this.refs.Messchild.showWarn("Please update PackOF of This Product");
            return;
        }
        else if (this.state.scanItems.length == 0) {
            this.refs.Messchild.showWarn("Scan First");
            return;
        }
        else {
            this.setState({ productLoading: false });
            const formData = {
                //createdBy
                cartonMasterId: this.state.PackOF,
                scanned: this.state.scanItems,
            }
            setTimeout(() => {
                this.SecondaryPackingService.Save(formData).then(data => {
                    const resdata = data.data;
                    this.setState({ productLoading: true });
                    //if ResponseCode is 200 success else error or warning message
                    if (resdata !== null && resdata.ResponseCode === '200') {
                        debugger

                        this.refs.Messchild.showSuccess(resdata.ResponseMessage);
                        this.PrintSecondaryPackagingService.formPreview1([resdata.ResponseData]);

                        // this.setState({
                        //     IsDisabledCartonDDL: false
                        // })
                        this.setState({
                            RemainingQuantity: null,
                            PackOF: null,
                            BatchNo: null,
                            ProcessOrder: null
                        });
                        this.state.scanItems = [];
                        this.setState({
                            scanItems: []
                        });
                        this.GetSecondaryPacking();

                    } else if (resdata.ResponseCode === '400') {
                        this.refs.Messchild.showWarn(resdata.ResponseMessage);
                    } else {
                        this.refs.Messchild.showError(resdata.ResponseMessage);
                    }
                });
            }, 1000);
        }
    }
    // get active carton drop down list
    GetActiveCartonDDL() {
        debugger
        this.CartonMasterService.GetActiveCartonDDL().then(data => {
            const resdata = data.data;
            //if ResponseCode is 200
            if (resdata !== null && resdata.ResponseCode === '200') {
                this.setState({
                    CartonDDL: resdata.ResponseData
                });
            }
        });
    }
    // scan qr code
    // ScanItem(e) {  // scan without url
    //     if (e.key === 'Enter') {
    //         let qr = e.target.value;
    //         if (qr.includes("QRLink")) {
    //             /////////for multiline qr code on KREPL//
    //             const splitQr = qr.split('QRLink:');
    //             console.log(splitQr[1]);
    //             /////////for multiline qr code on KREPL//
    //             /////////for multiline qr code on KREPL//  splitQr[splitQr.length-1].trim()
    //             qr = splitQr[1] === undefined ? qr : splitQr[1];
    //             /////////for multiline qr code on KREPL//
    //         }
    //         if (this.state.CartonId.length == 0) {
    //             this.refs.Messchild.showWarn("Select Carton Size");
    //             return;
    //         }
    //         else if (this.state.CartonId.CartonSize == this.state.scanItems.length) {
    //             this.refs.Messchild.showWarn("Carton Full");
    //             return;
    //         }
    //         if (qr.length == 17) {
    //             debugger
    //             console.log(qr);
    //             //Run in local selve sy
    //             const url = "http://localhost:3000/pa?uid=";
    //             //Use for testing
    //             //const url ="http://104.211.167.63:5153/pa?uid=";
    //             //Use For Live 
    //             //const url ="http://localhost:3000/pa?uid=";
    //             const fObj = { UID: url + qr }
    //             //const fObj = { UID: qr }
    //             this.MappingService.GetProductByQrScan(fObj).then(data => {
    //                 const resdata = data.data;
    //                 //if ResponseCode is 200 success else error or warning message
    //                 if (resdata !== null && resdata.ResponseCode === 200) {
    //                     if (this.state.scanItems.length > 0) {
    //                         debugger
    //                         let checkseqNo = this.state.scanItems.filter(y => y.SeqNo == resdata.SeqNo)
    //                         if (checkseqNo.length > 0) {
    //                             this.refs.Messchild.showWarn("already Scanned");
    //                             return;
    //                         }
    //                         // let IscheckSameProduct = this.state.scanItems.filter(y => y.ProductID == resdata.ProductID)
    //                         // if (IscheckSameProduct.length == 0) {
    //                         //     this.refs.Messchild.showWarn("You can pack only same product");
    //                         //     return;
    //                         // }
    //                     }
    //                     // const newArray = this.state.scanItems.slice(); // Create a copy
    //                     // newArray.push(resdata); // Push the object
    //                     // this.setState({ scanItems: newArray });
    //                     let lists = this.state.scanItems;
    //                     lists.push(resdata);
    //                     this.setState({
    //                         scanItems: lists
    //                     });
    //                     console.log(this.state.scanItems);
    //                     this.setState({
    //                         IsDisabledCartonDDL: true,
    //                         scanTxt: "" //KREP-55 defect
    //                     })
    //                 }
    //                 else
    //                     this.refs.Messchild.showWarn(resdata.ResponseMessage);
    //             });
    //         }
    //         else
    //             this.refs.Messchild.showWarn("Invalid scanned Qr");
    //         this.setState({
    //             scanTxt: ""
    //         });
    //         e.target.value = "";
    //     }
    // }
    // scan qr code

    ScanItem(e) {   // scan with url
        if (e.key === 'Enter') {
            e.preventDefault()
            let qr1 = "http://" + e.target.value;
            let qr = qr1;
            if (qr.includes("QRLink")) {
                /////////for multiline qr code on KREPL//
                const splitQr = qr.split('QRLink:');
                console.log(splitQr[1]);
                /////////for multiline qr code on KREPL//
                /////////for multiline qr code on KREPL//  splitQr[splitQr.length-1].trim()
                qr = splitQr[1] === undefined ? qr : splitQr[1];
                /////////for multiline qr code on KREPL//
            }
            // if (this.state.CartonId.length == 0) {
            //     this.refs.Messchild.showWarn("Select Carton Size");
            //     return;
            // }
            // else if (this.state.CartonId.CartonSize == this.state.scanItems.length) {
            //     this.refs.Messchild.showWarn("Carton Full");
            //     return;
            // }
            else if (this.state.PackOF == this.state.scanItems.length) {
                this.submitForm()
                return;
                
            }
            if (qr.includes("uid")) {
                console.log(qr);
                const fObj = { UID: qr }
                this.MappingService.GetProductByQrScan(fObj).then(data => {
                    debugger
                    const resdata = data.data;
                    //if ResponseCode is 200 success else error or warning message
                    if (resdata !== null && resdata.ResponseCode === 200) {
                        // this.setState({
                        //     RemainingQuantity: resdata.UnpackedQuantity,
                        //     PackOF: resdata.PackOF,
                        //     BatchNo: resdata.BatchNo,
                        //     ProcessOrder: resdata.Processorder
                        // })
                        
                        if (this.state.scanItems.length > 0) {
                            let checkseqNo = this.state.scanItems.filter(y => y.SeqNo == resdata.SeqNo)
                            if (checkseqNo.length > 0) {
                                this.refs.Messchild.showWarn("already Scanned");
                                return;
                            }

                            let IscheckSameProduct = this.state.scanItems.filter(y => y.ProductID == resdata.ProductID)
                            if (IscheckSameProduct.length == 0) {
                                this.refs.Messchild.showWarn("You can pack only same product");
                                return;
                            }
                        }
                        this.setState({
                            RemainingQuantity: resdata.UnpackedQuantity,
                            PackOF: resdata.PackOF,
                            BatchNo: resdata.BatchNo,
                            ProcessOrder: resdata.Processorder
                        })
                        // const newArray = this.state.scanItems.slice(); // Create a copy
                        // newArray.push(resdata); // Push the object
                        // this.setState({ scanItems: newArray });
                        let lists = this.state.scanItems;
                        lists.push(resdata);
                        this.setState({
                            scanItems: lists.sort((a, b) => b.SeqNo - a.SeqNo)
                        });
                        if (this.state.PackOF == this.state.scanItems.length) {
                            this.submitForm()
                            return;
                        }
                        console.log(this.state.scanItems.sort((a, b) => b.SeqNo - a.SeqNo));
                        // this.setState({
                        //     IsDisabledCartonDDL: true,
                        //     scanTxt: "" 
                        // })
                    }
                    else
                        this.refs.Messchild.showWarn(resdata.ResponseMessage);
                });
            }
            else
                this.refs.Messchild.showWarn("Invalid scanned Qr");
            this.setState({
                scanTxt: ""
            });
            e.target.value = "";
        }
    }
    // delete user data
    deleteScanned(SeqNo) {
        console.log(this.state.scanItems);
        let arrayfilter = this.state.scanItems.filter(x => x.SeqNo != SeqNo);
        this.setState({
            scanItems: arrayfilter
        });
        console.log(this.state.scanItems);
    }
    // seach table
    searchFilter(e) {
        this.setState({
            loading: true
        });
        this.tblResponse.SearchValue = e.target.value;
        this.GetSecondaryPacking();
    }
    callbackFunction = (childData) => {
        this.setState({ message: childData })
    }
    // disabled checkbox
    activeTemplate(rowData, column) {
        return (
            <input type="checkbox" disabled checked={rowData.IsActive} />
        )
    }
    // Sort table
    onSort(event) {
        this.setState({ ortOrder: this.state.sortOrder === 1 ? 2 : 1 });
        const sortField = event.sortField == "CreatedDt" ? "CreatedDt" : event.sortField;
        this.tblResponse.SortColumn = sortField ? sortField : "";
        this.tblResponse.SortOrder = this.state.sortOrder === 1 ? 'DESC' : 'ASC';
        this.GetSecondaryPacking();
        const clickData = document.getElementsByClassName("p-sortable-column-icon pi pi-fw pi-sort");
        console.log(event);
    }
    // edit form 
    actionTemplate(rowData, column) {
        const deleteFunc = () => {
            confirmAlert({
                title: 'Confirm to delete',
                message: 'Are you sure to do this.',
                buttons: [
                    {
                        label: 'Yes',
                        onClick: () => this.deleteScanned(rowData.SeqNo)
                    },
                    {
                        label: 'No',
                        onClick: () => null
                    }
                ]
            });
        }
        return <span>
            <Button type="button" icon="pi pi-trash" onClick={deleteFunc} className="p-button-danger"></Button>
        </span>;
    }
    // create html part
    render() {
        let header = (
            <div className="row">
                <div className="col-md-12 text-left">
                    <form className="form-inline">

                        {/* <div className="form-group ml-3" style={{ width: '20%' }}>
                            <label className="ml-2 mr-2">Carton Size:</label>
                            <Dropdown disabled={this.state.IsDisabledCartonDDL} />
                            <div style={{ marginLeft: '5px' }}>
                                <span style={{ backgroundColor: 'white', color: 'Green' }}> {this.state.PackOF}</span>
                            </div>
                        </div> */}
                        <div className="col-md-12 row">
                            <div className="form-group col-md-8">
                                <label>Scan items:</label>
                                {/* <input  value={this.state.scanTxt} type="search" className="form-control ml-2" id="scan" onChange={e => {this.ScanItem(e) }} /> */}
                                <input name="scanTxt" type="search" className="form-control ml-2" id="scan" onKeyDown={e => { this.ScanItem(e) }} />

                            </div>
                            <div className="col-md-4">
                                <i className="pi pi-search" style={{ margin: '4px 4px 0 0' }}></i>
                                <InputText type="search" onInput={(e) => this.setState({ globalFilter: e.target.value })} placeholder="Global Search" size="30" />
                            </div>
                        </div>

                        <div className="col-md-12 row mt-4">
                        <div className="form-group" style={{ width: '20%' }}>
                            <label>Available Quantity: </label>
                            <div style={{ marginLeft: '5px' }}>
                                <span style={{ backgroundColor: 'white', color: 'Green' }}> {this.state.RemainingQuantity}</span>
                            </div>

                        </div>
                        <div className="form-group" style={{ width: '20%' }}>
                            <label>Scanned Count: </label>
                            <div style={{ marginLeft: '5px' }}>
                                <span style={{ backgroundColor: 'white', color: 'Green' }}> {this.state.scanItems.length}</span>
                            </div>

                        </div>
                        <div className="form-group" style={{ width: '20%' }}>
                            <label>Carton Size: </label>
                            <div style={{ marginLeft: '5px' }}>
                                <span style={{ backgroundColor: 'white', color: 'Green' }}> {this.state.PackOF}</span>
                            </div>

                        </div>
                        <div className="form-group" style={{ width: '20%' }}>
                            <label>Batch NO: </label>
                            <div style={{ marginLeft: '5px' }}>
                                <span style={{ backgroundColor: 'white', color: 'Green' }}> {this.state.BatchNo}</span>
                            </div>

                        </div>
                        <div className="form-group" style={{ width: '20%' }}>
                            <label>Process Order: </label>
                            <div style={{ marginLeft: '5px' }}>
                                <span style={{ backgroundColor: 'white', color: 'Green' }}> {this.state.ProcessOrder}</span>
                            </div>

                        </div>
                        </div>
                        
                    </form>
                </div>

            </div>
        );
        let header2 = (
            <div className="row">
                <div className="col-md-4">
                    <i className="pi pi-search" style={{ margin: '4px 4px 0 0' }}></i>
                    <InputText type="search" onInput={this.searchFilter} placeholder="Global Search" size="30" />
                </div>
            </div>
        );
        return (
            <>
                <MessageComponent ref="Messchild" />
                <ConfirmationModal parentCallback={this.callbackFunction} ref="child" />
                <div className="heading">
                    <h1>Secondary Packing</h1>
                    {/* <Button label="Add Packing" icon="pi pi-plus-circle" onClick={this.openDialog} /> */}
                </div>
                <Loaders loader={this.state.productLoading} classType="small" />
                <DataTable responsive={true} header={header}
                    emptyMessage={this.state.emptyMessage} value={this.state.scanItems} sortMode="multiple" paginator={true}
                    rows={this.state.rows} className="tblAuto" globalFilter={this.state.globalFilter}>
                    <Column field="SeqNo" header="Visible No" sortable={true} />
                    <Column field="ProductName" header="Product Name" sortable="custom" />
                    <Column field="MFGDate" header="MFG Date" />
                    <Column body={this.actionTemplate} header="Action" />
                </DataTable>
                <div className="col-md-12 text-center mt-4 mb-4">
                    {/* <button className="btn btn-primary" onClick={this.submitForm}>Submit</button> */}
                </div>
                <div className="col-md-12 p-0">
                    <Loaders loader={this.state.cartoonLoading} classType="small" />
                    <DataTable responsive={true} header={header2} globalFilter={this.state.globalFilter}
                        emptyMessage={this.state.emptyMessage} value={this.state.sales} sortMode="multiple" paginator={true}
                        rows={this.state.rows} rowsPerPageOptions={[5, 10, 20]}
                        totalRecords={this.state.totalRecords} lazy={true} first={this.state.first}
                        onPage={this.onPage} onSort={this.onSort} className="tblAuto">
                        <Column field="Id" headerStyle={{ width: '140px' }} header="Id" sortable={true} />
                        <Column field="ProductName" headerStyle={{ width: '250px' }} header="Product Name" sortable={true} />
                        <Column field="BatchNo" headerStyle={{ width: '250px' }} header="Batch No" sortable={true} />
                        <Column field="CartonId" headerStyle={{ width: '250px' }} header="CartonId" sortable={true} />
                        <Column field="TotalQty" headerStyle={{ width: '250px' }} header="Total Qty" sortable="custom" />

                        <Column field="CartonName" headerStyle={{ width: '250px' }} header="Carton Size" style={{ width: '200px' }} sortable={true} />
                        <Column field="CreatedDt" headerStyle={{ width: '250px' }} header="Created Date" sortable={true} />

                    </DataTable>
                </div>
            </>
        )
    }
}